import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import Image from "antd/lib/image";
import Popover from "antd/lib/popover";
import Tooltip from "antd/lib/tooltip";
import CarouselWidgetMaker from "./Carousel";
import Profile from "../../assets/Profile_Pic.svg";
import fx from "../../assets/WidgetMaker/FX.svg";
import InfoIcon from "../../assets/Info_Icon.svg";
import BoostedPostIcon from "../../assets/boosted_post_icon.svg";
import AdsPostIcon from "../../assets/ads_post_icon.svg";
import defaultImg from "../../assets/WidgetMaker/Brocken_Image.svg";
import Default_Brand from "../../assets/brandLogos/Default_Brand.svg";
import userFollowers from "../../assets/FollowersBlue.svg";
import ClockIcon from "../../assets/Clock.svg";
import verified from "../../assets/verified.svg";
import somethingWentWrong from "../../assets/No_Data_Found.svg";
import NoDataImg from "../../assets/no-data-found.png";
import androidImage from "../../assets/android_icon_image.svg";
import { kFormatter } from "../../redux/constants";
import isEqual from "react-fast-compare";
import { SocialMedialogo } from "../layout/DeepDive/DeepDivetab/SocialMediaPlatforms";
import PaginationComponent from "./PaginationComponent";
import PostCardFooter from "./PostCardFooter";
import PostCardFilters from "./PostCardFilters";
import SortBy from "./SortBy";
import moment from "moment";
import PostCardDetails from "./PostCardDetails";
import QuotedPost from "./QuotedPost";
import { Rate } from "antd";
import PostAttachment from "./PostAttachment";
import SurveyAttachment from "./SurveyAttachment";

const SurveyCard = ({
  data,
  filterPills,
  totalPageNo,
  metadata,
  section_index,
  widget_index,
  mentionPage,
  pagination,
  deepDive,
  isPreviewState,
  dashboard,
  PdfDownloadStatus,
  PptGeneratingStatus,
  widget_id,
  noteExist,
  chart_type,
  isCommandCenterScreen,
  isDeepDiveDashboardView = false,
}) => {
  const isScheduleReportOpen = useSelector(
    (state) => state?.ApiCall?.is_schedule_report_open
  );
  const authParams = useSelector((state) => state.Authentication.authParams);
  const [visible, setVisible] = useState({ id: null, value: false });
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalLoader, setIsModalLoader] = useState(false);
  const [modalData, setIsModalData] = useState(null);
  const [isImage, setIsImage] = useState({});
  const Section = useSelector((state) => state.Section.addSection);
  const isshowSideBar = useSelector((state) => state.WidgetMaker.isshowSideBar);
  let currentPath = window.location.pathname;
  let splitPath = currentPath.split("/");
  const handleWindowResize = () => {
    setWindowWidth(window.innerWidth);
  };

  let widget_metadata = Section?.[section_index]?.data?.[widget_index];

  useEffect(() => {
    window.addEventListener("resize", handleWindowResize);
    return () => {
      window.removeEventListener("resize", handleWindowResize);
    };
  }, []);

  const showModal = (data) => {
    setIsModalLoader(true);
    setIsModalOpen(true);
    setIsModalData(data);
  };
  const getDefautBrandImg = (e) => {
    return (e.target.src = Default_Brand);
  };
  const onImageError = (e, id) => {
    if (e?.type === "error") {
      setIsImage({
        ...isImage,
        [id]: true,
      });
    } else {
      setIsImage({
        ...isImage,
        [id]: false,
      });
    }
    return (e.target.src = defaultImg);
  };

  return (
    <>
      {/* <PostCardFilters
        filterPills={filterPills}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        deepDive={deepDive}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        widget_id={widget_id}
        chart_type={chart_type}
      /> */}
      {/* {deepDive ||
      splitPath[1] === "widgetMaker" ||
      splitPath[1] === "edit-widget" ? (
        <div
          id={`post_card_${section_index ? section_index : "section_index"}_${
            widget_index ? widget_index : "widget_index"
          }`}
          className={`w-100 wm-chart-cards text-right`}
        >
          <SortBy
            filterPills={filterPills}
            metadata={metadata}
            section_index={section_index}
            widget_index={widget_index}
            isPreviewState={isPreviewState}
            PdfDownloadStatus={PdfDownloadStatus}
            PptGeneratingStatus={PptGeneratingStatus}
            widget_id={widget_id}
            chart_type={chart_type}
            dashboard={dashboard}
            deepDive={deepDive}
          />
        </div>
      ) : (
        <></>
      )} */}

      {data?.length > 0 ? (
        <>
          <div
            className={`row mr-15 ml-0 mb-1  ${
              PdfDownloadStatus ||
              PptGeneratingStatus ||
              (splitPath[1] !== "widgetMaker" &&
                splitPath[1] !== "edit-widget" &&
                !deepDive) ||
              true // because currently we are not showing any sorting option there
                ? "pt-15"
                : ""
            }`}
          >
            {data?.map((el, i) => {
              if (
                (PdfDownloadStatus || PptGeneratingStatus) &&
                noteExist &&
                i > 2
              )
                return null;
              // if (PptGeneratingStatus) {
              //   if (windowWidth <= 1300) {
              //     if (windowWidth <= 850 && i > 2) return null;
              //     else if (i > 3) return null;
              //   } else if (windowWidth > 1300 && windowWidth <= 2450) {
              //     if (windowWidth <= 1846 && i > 5) return null;
              //     else if (i > 7) return null;
              //   } else if (windowWidth > 2450 && i > 11) {
              //     return null;
              //   }
              // }
              if ((PdfDownloadStatus || PptGeneratingStatus) && i > 5)
                return null;

              return (
                <div
                  key={`${el?.TagID}_${i}`}
                  className={`${!dashboard ? "col-md-6" : "col-md-4"} pr-0`}
                  // className={`${
                  //   PdfDownloadStatus ? "col-4 col-md-4" : "col-12 col-md-6"}
                  // } ${!dashboard ? "col-lg-6" : "col-lg-4"} ${
                  //   PdfDownloadStatus || PptGeneratingStatus
                  //     ? ""
                  //     : isPreviewState
                  //     ? windowWidth < 1400
                  //       ? "col-md-12 col-lg-12"
                  //       : windowWidth > 2450
                  //       ? "col-xl-4"
                  //       : "col-lg-6"
                  //     : (!isshowSideBar || isshowSideBar) &&
                  //       !dashboard &&
                  //       !mentionPage
                  //     ? windowWidth < 1400
                  //       ? "col-md-12 col-lg-12"
                  //       : windowWidth > 1846 && windowWidth <= 2200
                  //       ? "col-md-6"
                  //       : windowWidth > 2200
                  //       ? "col-xl-3"
                  //       : "col-lg-6"
                  //     : metadata?.span === "one_third" ||
                  //       widget_metadata?.span === "one_third"
                  //     ? windowWidth > 2450
                  //       ? "col-md-6 col-lg-6"
                  //       : "col-md-12 col-lg-12"
                  //     : metadata?.span === "two_third" ||
                  //       widget_metadata?.span === "two_third"
                  //     ? windowWidth < 1300
                  //       ? "col-md-12 col-lg-12"
                  //       : windowWidth > 1526 && windowWidth <= 2450
                  //       ? windowWidth <= 1850
                  //         ? "col-xl-6"
                  //         : "col-md-6"
                  //       : windowWidth > 2450
                  //       ? "col-xl-3"
                  //       : "col-md-6 col-lg-6"
                  //     : metadata?.span === "half" ||
                  //       widget_metadata?.span === "half"
                  //     ? windowWidth < 1700
                  //       ? "col-md-12 col-lg-12"
                  //       : "col-md-6 col-lg-6"
                  //     : windowWidth < 1300
                  //     ? windowWidth < 850
                  //       ? "col-sd-12 col-md-12 col-lg-6"
                  //       : "col-sd-12 col-lg-6"
                  //     : windowWidth > 1526 && windowWidth <= 2450
                  //     ? windowWidth <= 1846
                  //       ? "col-md-6"
                  //       : "col-xl-3"
                  //     : windowWidth > 2450 && "col-xl-2"
                  // } pr-0`}
                >
                  <div className="card cardList postCardItem border-0 mb-2 text-left">
                    <div
                    //
                    >
                      <div className="d-flex align-items-center">
                        {/* {el?.SentimentType ? (
                          <div
                            style={{
                              borderLeft: `0.4rem solid ${
                                el?.SentimentType === "Positive"
                                  ? "#5ED142"
                                  : el?.SentimentType === "Negative"
                                  ? "#FF5D48"
                                  : el?.SentimentType === "Neutral"
                                  ? "#F0C52F"
                                  : "black"
                              }`,
                              height: "3.6rem",
                              marginRight: "1rem",
                            }}
                          ></div>
                        ) : (
                          ""
                        )} */}
                        {/* {el?.brand_logo &&
                        el?.brand_logo !== "NA" &&
                        el?.BrandFriendlyName &&
                        el?.BrandFriendlyName !== "NA" &&
                        el?.BrandFriendlyName !== "" ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              <div
                                style={{
                                  maxWidth: "25rem",
                                  maxHeight: "20rem",
                                  overflow: "auto",
                                }}
                                className="text_regular fontSize-12 p-10"
                              >
                                {el?.BrandFriendlyName}
                              </div>
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                el?.brand_logo ? el?.brand_logo : Default_Brand
                              }
                              fallback={
                                el?.brand_logo ? el?.brand_logo : Default_Brand
                              }
                              preview={false}
                              alt="Brand logo"
                              className="profileImg mr-1 cursor-pointer"
                              style={{
                                width: "3.5rem",
                                height: "3.5rem",
                                //marginTop: "-0.5rem",
                              }}
                              onError={getDefautBrandImg}
                              // crossOrigin="anonymous"
                            />
                          </Popover>
                        ) : el?.BrandFriendlyName &&
                          el?.BrandFriendlyName !== "NA" &&
                          el?.BrandFriendlyName !== "" ? (
                          <Popover
                            placement="leftBottom"
                            title={null}
                            content={
                              <div
                                style={{
                                  maxWidth: "25rem",
                                  maxHeight: "20rem",
                                  overflow: "auto",
                                }}
                                className="text_regular fontSize-12 p-10"
                              >
                                {el?.BrandFriendlyName}
                              </div>
                            }
                            overlayClassName={
                              authParams?.theme_type === "1"
                                ? "darkTheme"
                                : "lightTheme"
                            }
                          >
                            <Image
                              src={
                                el?.brand_logo && el?.brand_logo !== "NA"
                                  ? el?.brand_logo
                                  : Default_Brand
                              }
                              fallback={
                                el?.brand_logo && el?.brand_logo !== "NA"
                                  ? el?.brand_logo
                                  : Default_Brand
                              }
                              preview={false}
                              alt="Brand logo"
                              onError={getDefautBrandImg}
                              className="profileImg mr-1 cursor-pointer"
                              style={{
                                width: "3.5rem",
                                height: "3.5rem",
                                //marginTop: "-0.5rem",
                              }}
                              // crossOrigin="anonymous"
                            />
                          </Popover>
                        ) : (
                          <Image
                            src={
                              el?.brand_logo && el?.brand_logo !== "NA"
                                ? el?.brand_logo
                                : Default_Brand
                            }
                            fallback={
                              el?.brand_logo && el?.brand_logo !== "NA"
                                ? el?.brand_logo
                                : Default_Brand
                            }
                            preview={false}
                            alt="Brand logo"
                            onError={getDefautBrandImg}
                            className="profileImg mr-1 cursor-pointer"
                            style={{
                              width: "3.5rem",
                              height: "3.5rem",
                              //marginTop: "-0.5rem",
                            }}
                            // crossOrigin="anonymous"
                          />
                        )} */}
                        {/* <div
                          className="position-relative mr-15"
                          style={{ width: "3.5rem" }}
                        >
                          {!PdfDownloadStatus && !PptGeneratingStatus ? (
                            el?.AuthorBio &&
                            el?.AuthorBio !== "NA" &&
                            el?.AuthorBio !== "" ? (
                              <Popover
                                placement="leftBottom"
                                title={null}
                                content={
                                  el?.AuthorBio &&
                                  el?.AuthorBio !== "NA" &&
                                  el?.AuthorBio !== "" && (
                                    <div
                                      style={{
                                        maxWidth: "25rem",
                                        maxHeight: "20rem",
                                        overflow: "auto",
                                      }}
                                      className="text_regular fontSize-12 p-15 custom_scroll1"
                                    >
                                      {el?.AuthorBio}
                                    </div>
                                  )
                                }
                                overlayClassName={
                                  authParams?.theme_type === "1"
                                    ? "darkTheme"
                                    : "lightTheme"
                                }
                              >
                                <Image
                                  src={
                                    el?.ProfilePicture === 0 ||
                                    el?.ProfilePicture === "" ||
                                    !el?.ProfilePicture
                                      ? Profile
                                      : el?.ProfilePicture
                                  }
                                  fallback={Profile}
                                  preview={false}
                                  alt="Profile Images"
                                  className="profileImg m-0 cursor-pointer"
                                  style={{ width: "3.5rem", height: "3.5rem" }}
                                  crossOrigin="anonymous"
                                />
                              </Popover>
                            ) : (
                              <Image
                                src={
                                  el?.ProfilePicture === 0 ||
                                  el?.ProfilePicture === "" ||
                                  !el?.ProfilePicture
                                    ? Profile
                                    : el?.ProfilePicture
                                }
                                fallback={Profile}
                                preview={false}
                                alt="Profile Images"
                                className="profileImg m-0 cursor-pointer"
                                style={{ width: "3.5rem", height: "3.5rem" }}
                                crossOrigin="anonymous"
                              />
                            )
                          ) : (
                            <Image
                              src={
                                PdfDownloadStatus || PptGeneratingStatus
                                  ? el?.ProfilePicture === 0 ||
                                    el?.ProfilePicture === "" ||
                                    !el?.ProfilePicture
                                    ? Profile
                                    : el?.ProfilePicture
                                  : Profile
                              }
                              fallback={Profile}
                              preview={false}
                              alt="Profile Images"
                              className="profileImg m-0 cursor-pointer"
                              style={{ width: "3.5rem", height: "3.5rem" }}
                              crossOrigin="anonymous"
                            />
                          )}
                          <div
                            className="position-absolute"
                            style={{
                              right: "-0.8rem",
                              top: "-0.4rem",
                            }}
                          >
                            <Image
                              src={
                                el?.PlatformID === 0
                                  ? Default_Brand
                                  : SocialMedialogo?.[el?.PlatformID]
                                  ? SocialMedialogo?.[el?.PlatformID]
                                  : Default_Brand
                              }
                              alt="Channel"
                              preview={false}
                              fallback={Default_Brand}
                              style={{
                                width: "1.6rem",
                                maxHeight: "2rem",
                                verticalAlign: "top",
                              }}
                            />
                          </div>
                        </div> */}
                        {/* <div style={{ width: "calc(100% - 6rem)" }}>
                          <div className="d-flex flex-wrap align-items-center">
                            <Tooltip title={el?.AuthorName}>
                              <div
                                className="profileName text-ellipsis line-height-normal"
                                style={{
                                  maxWidth:
                                    (el?.AuthorIsVerified !== "NA" &&
                                      el?.AuthorIsVerified &&
                                      el?.AuthorIsVerified > 0) ||
                                    [1, 2]?.includes(el?.isPromoted)
                                      ? "calc(100% - 2.5rem)"
                                      : "",
                                }}
                              >
                                {el?.AuthorName}
                              </div>
                            </Tooltip>
                            {el?.AuthorIsVerified !== "NA" &&
                            el?.AuthorIsVerified &&
                            el?.AuthorIsVerified > 0 ? (
                              <img
                                src={verified}
                                alt="verified"
                                className="profileImg ml-1"
                                style={{ height: "1.6rem" }}
                              />
                            ) : (
                              ""
                            )}
                               {el?.isPromoted === 1 ? (
                              <Tooltip title="Boosted post">
                                <img
                                  alt="Boosted Post Icon"
                                  src={BoostedPostIcon}
                                  className="mr-0"
                                  style={{
                                                width: "2rem",
                                                height: "2rem",
                                              }}
                                />
                              </Tooltip>
                            ) : el?.isPromoted === 2 ? (
                              <Tooltip title="Ad post">
                                <img
                                  alt="Ad Post Icon"
                                  src={AdsPostIcon}
                                  className="mr-0"
                                  style={{
                                                width: "2rem",
                                                height: "2rem",
                                              }}
                                />
                              </Tooltip>
                            ) : (
                              ""
                            )}
                          </div>
                          {el?.AuthorScreenName ? (
                            <div
                              className="screenName text-grayLight text-ellipsis w-100"
                              //style={{ width: "90%" }}
                            >
                              <Tooltip title={el?.AuthorScreenName}>
                                {el?.AuthorScreenName}
                              </Tooltip>
                            </div>
                          ) : (
                            ""
                          )}
                        </div> */}
                      </div>
                    </div>
                    <div
                      className={
                        isScheduleReportOpen ||
                        PdfDownloadStatus ||
                        PptGeneratingStatus
                          ? ""
                          : "card-body p-0"
                      }
                    >
                      {!PdfDownloadStatus && el?.PlatformID === 1 && (
                        <div
                          className={`${
                            PdfDownloadStatus ? "mb-5" : "mb-15"
                          }  pl-15 d-flex pr-15 no--wrap`}
                        ></div>
                      )}
                      {(el?.PlatformID === 7 || el?.PlatformID === 30) &&
                      el?.IsBrandPost === "User" ? (
                        <>
                          <div className="mb-2 pl-15 d-flex justify-content-between pr-15">
                            {el?.Rating >= 0 ? (
                              <span className="mr-15 d-flex align-items-center">
                                {/* <Rate
                                  disabled
                                  value={el?.Rating ? el?.Rating : el?.rating}
                                  className="no--wrap w-100 ratingList mr-1 "
                                /> */}
                                {el?.Rating}
                              </span>
                            ) : (
                              ""
                            )}
                            {el?.PlatformID === 7 ? (
                              <span className="mr-15 d-flex align-items-center">
                                <span
                                  className="w-100 text-ellipsis mr-1"
                                  style={{ color: "blue" }}
                                >
                                  App Version:
                                </span>
                                {el?.App_version}
                              </span>
                            ) : (
                              ""
                            )}
                            {el?.PlatformID === 7 ? (
                              <span className="mr-15 d-flex align-items-center">
                                <img
                                  src={androidImage}
                                  alt="Android Image"
                                  className="profileImg ml-1 mr-1"
                                  style={{ width: "1.5rem" }}
                                />
                                {el?.Android_version}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          {el?.PlatformID === 7 ? (
                            <span className="ml-15 mb-5 d-flex align-items-center">
                              <span className="d-flex w-100">
                                <span
                                  style={{ color: "blue" }}
                                  className="text-ellipsis mr-1"
                                >
                                  Device Name:
                                </span>
                                <span className="text-ellipsis">
                                  {el?.Device}
                                </span>
                              </span>
                            </span>
                          ) : (
                            ""
                          )}
                        </>
                      ) : (
                        ""
                      )}

                      <SurveyAttachment
                        el={el}
                        i={i}
                        PdfDownloadStatus={PdfDownloadStatus}
                        PptGeneratingStatus={PptGeneratingStatus}
                        data={data}
                        isPreviewState={isPreviewState}
                        postText={el?.Description}
                        graphData={el?.graphData}
                        deepDive={deepDive}
                        custom_card_settings={metadata}
                        isCommandCenterScreen={isCommandCenterScreen}
                        widget_id={`${widget_id}` + `${i}`}
                        isScheduleReportOpen={isScheduleReportOpen}
                        section_index={section_index}
                        widget_index={widget_index}
                        isDeepDiveDashboardView={isDeepDiveDashboardView}
                      />
                      {
                        el?.EmailContentHtml !== "NA" &&
                          el?.EmailContentHtml &&
                          ""
                        //   <QuotedPost
                        //     el={el?.EmailContentHtml}
                        //     i={i}
                        //     PdfDownloadStatus={PdfDownloadStatus}
                        //     PptGeneratingStatus={PptGeneratingStatus}
                        //   />
                      }
                    </div>
                    <div>
                      {/* <PostCardFooter
                        data={data}
                        isPreviewState={isPreviewState}
                        PdfDownloadStatus={PdfDownloadStatus}
                        PptGeneratingStatus={PptGeneratingStatus}
                        el={el}
                        deepDive={deepDive}
                      /> */}
                      {
                        el?.PlatformID === 7 || el?.PlatformID === 30 ? "" : ""
                        //         <div className="card-footer text-center bg__white text_regular d-flex align-items-top pt-2 pb-2 pl-15 pr-15 border-top border-color">
                        //           <div className="mr-15" style={{ width: "25%" }}>
                        //             <div className="text_regular text-grayLight white-space-nowrap">
                        //               Engagement
                        //             </div>
                        //             <div
                        //               className={`${
                        //                 PdfDownloadStatus ? "" : "font-size18"
                        //               } text_heading-Rubik line-height-normal`}
                        //             >
                        //               {PdfDownloadStatus ? (
                        //                 <>
                        //                   <div>
                        //                     {kFormatter(el?.Engagement)}{" "}
                        //                     {el?.engagement_fx ? (
                        //                       <Tooltip title={el?.Engagement_text}>
                        //                         <img
                        //                           src={fx}
                        //                           style={{ maxWidth: "1.5rem" }}
                        //                           className="mr-1 cursor-pointer"
                        //                           alt="fx"
                        //                         />
                        //                       </Tooltip>
                        //                     ) : (
                        //                       ""
                        //                     )}{" "}
                        //                   </div>
                        //                 </>
                        //               ) : (
                        //                 <>
                        //                   <div>{kFormatter(el?.Engagement)}</div>
                        //                   {el?.engagement_fx ? (
                        //                     <Tooltip title={el?.Engagement_text}>
                        //                       <img
                        //                         src={fx}
                        //                         style={{ maxWidth: "1.5rem" }}
                        //                         className="mr-1 cursor-pointer"
                        //                         alt="fx"
                        //                       />
                        //                     </Tooltip>
                        //                   ) : (
                        //                     ""
                        //                   )}
                        //                 </>
                        //               )}
                        //             </div>
                        //             {/* <Progress
                        //     percent={el?.Engagement}
                        //     showInfo={false}
                        //     trailColor={"#c0c2c5"}
                        //   /> */}
                        //           </div>
                        //           <div className="mr-15" style={{ width: "25%" }}>
                        //             <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                        //               <Tooltip title="Engagement Rate">
                        //                 <div className="white-space-nowrap">
                        //                   Eng. Rate
                        //                 </div>
                        //               </Tooltip>
                        //             </div>
                        //             <div
                        //               className={`${
                        //                 PdfDownloadStatus ? "" : "font-size18"
                        //               } text_heading-Rubik line-height-normal`}
                        //             >
                        //               {PdfDownloadStatus ? (
                        //                 <>
                        //                   <div>
                        //                     {kFormatter(el?.Engagement_rate)}{" "}
                        //                     <Tooltip title={el?.Engagement_rate_text}>
                        //                       <img
                        //                         src={fx}
                        //                         style={{ maxWidth: "1.5rem" }}
                        //                         className="mr-1 cursor-pointer"
                        //                         alt="fx"
                        //                       />
                        //                     </Tooltip>
                        //                   </div>
                        //                 </>
                        //               ) : (
                        //                 <>
                        //                   <div>{kFormatter(el?.Engagement_rate)}</div>
                        //                   <Tooltip title={el?.Engagement_rate_text}>
                        //                     <img
                        //                       src={fx}
                        //                       style={{ maxWidth: "1.5rem" }}
                        //                       className="mr-1 cursor-pointer"
                        //                       alt="fx"
                        //                     />
                        //                   </Tooltip>
                        //                 </>
                        //               )}
                        //             </div>
                        //             {/* <Progress
                        //     percent={el?.Engagement}
                        //     showInfo={false}
                        //     trailColor={"#c0c2c5"}
                        //   /> */}
                        //           </div>
                        //           <div className="mr-15" style={{ width: "25%" }}>
                        //             <div
                        //               className={`text_regular text-grayLight d-inline-flex align-items-center ${
                        //                 el?.reach_fx ? "cursor-pointer" : ""
                        //               }`}
                        //             >
                        //               {el?.reach_fx ? (
                        //                 <Tooltip title="Estimated Reach">
                        //                   <div className="white-space-nowrap">
                        //                     Est. Reach
                        //                   </div>
                        //                 </Tooltip>
                        //               ) : (
                        //                 <div className="white-space-nowrap">Reach</div>
                        //               )}
                        //               {el?.reach_i && (
                        //                 <Tooltip title="It looks like this video post has been watched by the same viewers multiple times.">
                        //                   <img
                        //                     src={InfoIcon}
                        //                     alt="InfoIcon"
                        //                     className="ml-1"
                        //                   />
                        //                 </Tooltip>
                        //               )}
                        //             </div>
                        //             <div
                        //               className={`${
                        //                 PdfDownloadStatus ? "" : "font-size18"
                        //               } text_heading-Rubik line-height-normal`}
                        //             >
                        //               {PdfDownloadStatus ? (
                        //                 <>
                        //                   <div>
                        //                     {kFormatter(el?.Reach)}{" "}
                        //                     {el?.reach_fx && (
                        //                       <Tooltip title={el?.Reach_text}>
                        //                         <img
                        //                           src={fx}
                        //                           style={{ maxWidth: "1.5rem" }}
                        //                           className="mr-1 cursor-pointer"
                        //                           alt="fx"
                        //                         />
                        //                       </Tooltip>
                        //                     )}
                        //                   </div>
                        //                 </>
                        //               ) : (
                        //                 <>
                        //                   <div> {kFormatter(el?.Reach)}</div>
                        //                   {el?.reach_fx && (
                        //                     <Tooltip title={el?.Reach_text}>
                        //                       <img
                        //                         src={fx}
                        //                         style={{ maxWidth: "1.5rem" }}
                        //                         className="mr-1 cursor-pointer"
                        //                         alt="fx"
                        //                       />
                        //                     </Tooltip>
                        //                   )}
                        //                 </>
                        //               )}
                        //             </div>
                        //             {/* <Progress
                        //     percent={el?.Reach}
                        //     showInfo={false}
                        //     trailColor={"#c0c2c5"}
                        //   /> */}
                        //           </div>
                        //           <div style={{ width: "25%" }}>
                        //             {el?.impression_fx ? (
                        //               <Tooltip title="Estimated Impression">
                        //                 <div className="text_regular text-grayLight white-space-nowrap cursor-pointer">
                        //                   {" "}
                        //                   {PdfDownloadStatus
                        //                     ? "Est. Impr."
                        //                     : "Est. Impression"}
                        //                 </div>
                        //               </Tooltip>
                        //             ) : (
                        //               <div className="text_regular text-grayLight white-space-nowrap">
                        //                 Impression
                        //               </div>
                        //             )}
                        //             <div
                        //               className={`${
                        //                 PdfDownloadStatus ? "" : "font-size18"
                        //               } text_heading-Rubik line-height-normal`}
                        //             >
                        //               {PdfDownloadStatus ? (
                        //                 <>
                        //                   <div>
                        //                     {kFormatter(el?.Impression, false, true)}
                        //                     {el?.impression_fx && (
                        //                       <Tooltip title={el?.Impression_text}>
                        //                         <img
                        //                           src={fx}
                        //                           style={{ maxWidth: "1.5rem" }}
                        //                           className="mr-1 cursor-pointer"
                        //                           alt="fx"
                        //                         />
                        //                       </Tooltip>
                        //                     )}
                        //                   </div>
                        //                 </>
                        //               ) : (
                        //                 <>
                        //                   <div>
                        //                     {kFormatter(el?.Impression, false, true)}
                        //                   </div>
                        //                   {el?.impression_fx && (
                        //                     <Tooltip title={el?.Impression_text}>
                        //                       <img
                        //                         src={fx}
                        //                         style={{ maxWidth: "1.5rem" }}
                        //                         className="mr-1 cursor-pointer"
                        //                         alt="fx"
                        //                       />
                        //                     </Tooltip>
                        //                   )}
                        //                 </>
                        //               )}
                        //             </div>
                        //             {/* <Progress
                        //     percent={el?.Impression}
                        //     showInfo={false}
                        //     trailColor={"#c0c2c5"}
                        //   /> */}
                        //           </div>
                        //         </div>
                      }
                    </div>
                  </div>
                </div>
              );
            })}
            {/* </StackGrid> */}
          </div>
        </>
      ) : (
        <div
          className="d-flex align-items-center justify-content-center w-100"
          style={{ minHeight: "calc(100vh - 21.3rem)" }}
        >
          <div className="text-center">
            <img
              alt="no data"
              src={
                authParams?.theme_type === "1" ? NoDataImg : somethingWentWrong
              }
              style={{ maxWidth: "100%", minWidth: "15rem" }}
            />
            <p className="mt-15 text_regular-gray">No Data Found</p>
          </div>
        </div>
      )}

      <PaginationComponent
        data={data}
        filterPills={filterPills}
        totalPageNo={totalPageNo}
        metadata={metadata}
        section_index={section_index}
        widget_index={widget_index}
        mentionPage={mentionPage}
        pagination={pagination}
        deepDive={deepDive}
        isPreviewState={isPreviewState}
        dashboard={dashboard}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        widget_id={widget_id}
        chart_type={chart_type}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      />
      {/* <PostCardDetails
        data={data}
        modalData={modalData}
        isPreviewState={isPreviewState}
        PdfDownloadStatus={PdfDownloadStatus}
        PptGeneratingStatus={PptGeneratingStatus}
        setIsModalOpen={setIsModalOpen}
        isModalOpen={isModalOpen}
        setIsModalData={setIsModalData}
        isModalLoader={isModalLoader}
        setIsModalLoader={setIsModalLoader}
        isDeepDiveDashboardView={isDeepDiveDashboardView}
      /> */}
    </>
  );
};

export default React.memo(SurveyCard, isEqual);
